import { doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  AccountResponse,
  AccountRestrictionsRequest,
  AccountRestrictionsResponse,
  AccountsResponse,
  AuthoriseResponse,
} from './types';

export const getAccount = (accountId: string) => {
  return doGet<AccountResponse>(`accounts/${accountId}`, LOGGER_TYPE.JUPITER, {
    version: 'v2',
  });
};

export const getAccounts = () => {
  return doGet<AccountsResponse>(`accounts`, LOGGER_TYPE.ACCOUNT, {
    version: 'v2',
  });
};

export const createAccount = (
  accountName: string,
  accountId?: string,
  expiryDate?: Date,
) => {
  const body: {
    account_name: string;
    account_id?: string;
    trial_expires?: string;
  } = {
    account_name: accountName,
  };

  if (accountId) {
    body.account_id = accountId;
  }

  if (expiryDate) {
    const year = expiryDate.getFullYear();
    const month = String(expiryDate.getMonth() + 1).padStart(2, '0');
    const day = String(expiryDate.getDate()).padStart(2, '0');
    body.trial_expires = `${year}-${month}-${day}`;
  }

  return doPost<AccountResponse>(`accounts`, LOGGER_TYPE.ACCOUNT, body, {
    version: 'v2',
  });
};

export const authoriseUser = () => {
  return doGet<AuthoriseResponse>(`authorise`, LOGGER_TYPE.ACCOUNT);
};

export const updateAccountRestrictions = (
  accountId: string,
  restrictions: AccountRestrictionsRequest,
) => {
  return doPatch<AccountRestrictionsResponse>(
    `accounts/${accountId}/restrictions`,
    LOGGER_TYPE.ACCOUNT,
    restrictions,
    {
      version: 'v2',
      prefix: 'jupiter',
    },
  );
};

export const extendAccountTrial = (accountId: string) => {
  return doPost<AccountRestrictionsResponse>(
    `accounts/${accountId}/extend-trial`,
    LOGGER_TYPE.ACCOUNT,
    {},
    {
      version: 'v2',
      prefix: 'jupiter',
    },
  );
};
